import styled from 'styled-components';

import { TableMotives, pickMotive } from './tableMotives';

export type StyledTableProps = {
  motive?: TableMotives;
};

const Wrapper = styled.div`
  overflow: auto;
`;

const Table = styled.table<StyledTableProps>`
  width: 100%;

  border-collapse: 0;
  border-spacing: 0;

  ${({ motive }) => motive && pickMotive(motive)};
`;

export { Wrapper, Table };
